import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CCNotificationPriority, CCTextType } from '@heidelberg/control-center-frontend-integration';
import { NotificationSendingApiService } from '@data-terminal/data-access/notifications/notification-sending-api.service';
import { DCNotificationRequest, DCNotificationResponse } from '@data-terminal/shared-models/notification';

@Injectable({
    providedIn: 'root',
})
export class NotificationSendingService {
    private readonly notificationApiService = inject(NotificationSendingApiService);

    public sendGeneralNotification(body: DCNotificationRequest): Observable<DCNotificationResponse> {
        return this.notificationApiService.sendNotificationEvent(body);
    }

    public sendUserSignOffLeaveNotification(
        operator: string,
        machineId: string,
        userList: string[]
    ): Observable<DCNotificationResponse> {
        const body = {
            priority: CCNotificationPriority.info,
            recipients: userList,
            titleKey: 'DC.NOTIFICATION.SIGNOFFBYOPERATOR.TITLE',
            messageKey: 'DC.NOTIFICATION.SIGNOFFBYOPERATOR',
            messageArgs: {
                operator: {
                    textType: CCTextType.plain,
                    value: operator,
                },
                machineId: {
                    textType: CCTextType.plain,
                    value: machineId,
                },
            },
        } as DCNotificationRequest;
        return this.sendGeneralNotification(body);
    }
}
